import './NotFound.sass';

import React, { FC, useCallback } from 'react';

import { useTranslator } from '$hooks';
import { Button, LottieIcon, Placeholder } from '$uikit';
import { FEED } from '$shared/constants/pages';
import { MetaTags } from '$shared/components';
import router from '$navigation/router';

export const NotFound: FC = () => {
  const t = useTranslator();
  const iconSize = 56;

  const handleGoToHome = useCallback(() => {
    router.navigate(FEED);
    window.location.reload();
  }, []);

  return (
    <div className="NotFound">
      <MetaTags title={t('404_title')} />
      <Placeholder
        iconSize={iconSize}
        icon={<LottieIcon name="sad" size={iconSize} />}
        title={t('404_caption')}
        actions={
          <Button onClick={handleGoToHome} size={'small'}>
            {t('go_to_home')}
          </Button>
        }
      />
    </div>
  );
};
